<div class="copy-link-form">
  <button (click)="copyLink.emit()"><i ui-icon uiType="link"></i>{{ "copy_link" | localize }}</button>
  <input [ngModel]="url" ui-input disabled />
</div>
